import { reducerWrapper } from '../support/utils';

import { CSV_EXPORT } from '../actions/CsvExport';

const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
};

function Handler(state, action) {
  switch (action.type) {
    case CSV_EXPORT.response:
      return Object.assign({}, state, {
        loading: false,
        error: action.data && action.data.error,
        data: action.data,
      });

    default:
      return state;
  }
}

const CsvExport = reducerWrapper(INIT_STATE, Handler, {
  request: [CSV_EXPORT],
  error: [CSV_EXPORT],
});

export default CsvExport;
